export default __webpack_public_path__ + "static/media/multi-select-list.1836a8cd.png";